import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { reduxProps } from '../../constants';
import positionData from '../../data/position.json';
import {toast} from 'react-toastify';
import {actionUpdateStaff} from '../../redux/education/actions/staff.action';
import {actionSaveLogin} from '../../redux/auth';
import {IAuthInfoModel} from '../../constants';
import LoadingButton from "../LoadingButton";

const UserUrl = "https://production.gokidly.com/user/api/v2"; // API base URL

const UserSettings: React.FC = () => {
    const {staffInfo, authentication, roleId, device} = useSelector((state: reduxProps) => state.authReducer);
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        teacherRole: "2", // ID olarak tutuyoruz
    });

    const [emailError, setEmailError] = useState<string>("");

    // staffInfo verilerini form'a yükle
    useEffect(() => {
        if (staffInfo) {
            console.log("staffInfo", staffInfo)
            setFormData(prevState => ({
                ...prevState,
                firstName: staffInfo.name || "",
                lastName: staffInfo.lastName || "",
                email: staffInfo.email || "",
                teacherRole: staffInfo?.position?.toString() || "2",
            }));
        }
    }, [staffInfo]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        // E-posta değiştiğinde hata mesajını temizle
        if (e.target.name === 'email') {
            setEmailError("");
        }

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async () => {
        try {
            setEmailError("");

            const updatePayload = {
                active: true,
                name: formData.firstName,
                lastName: formData.lastName,
                organizationId: staffInfo.organizationId,
                schoolIds: staffInfo.schoolIds,
                classroomIds: staffInfo.classroomIds,
                positionId: parseInt(formData.teacherRole)
            };

            dispatch(actionUpdateStaff(staffInfo.id, updatePayload, (response) => {
                if (response.type === 'SUCCESS') {
                    console.log("responsedsadasdasd", response)
                    toast.success('Bilgileriniz başarıyla güncellendi');

                    // Sadece gerekli alanları güncelle
                    const updatedStaffInfo = {
                        ...staffInfo,
                        name: formData.firstName,
                        lastName: formData.lastName,
                        position: parseInt(formData.teacherRole)
                    };

                    const authPropsData: IAuthInfoModel = {
                        staffInfo: updatedStaffInfo,
                        authentication: authentication,
                        roleId: roleId,
                        device: device
                    };

                    dispatch(actionSaveLogin(authPropsData));
                } else {
                    toast.error('Bilgileriniz güncellenirken bir hata oluştu');
                }
            }));

        } catch (error) {
            console.error("Hata:", error);
            toast.error('Bir hata oluştu');
        }
    };

    return (
        <div className="form-container">
            <h2>Öğretmen Ayarları</h2>
            <div className="row">
                <div className="col col-6">
                    <label>
                        İsim
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                    </label>
                </div>
                <div className="col col-6">
                    <label>
                        Soyisim
                        <input
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                    </label>
                </div>
            </div>
            {/*<label>*/}
            {/*    E-posta*/}
            {/*    <input*/}
            {/*        type="email"*/}
            {/*        name="email"*/}
            {/*        value={formData.email}*/}
            {/*        onChange={handleChange}*/}
            {/*    />*/}
            {/*    {emailError && <div className="error">{emailError}</div>}*/}
            {/*</label>*/}
            {/*<label>*/}
            {/*    Şifre*/}
            {/*    <input*/}
            {/*        type="password"*/}
            {/*        name="password"*/}
            {/*        value={formData.password}*/}
            {/*        onChange={handleChange}*/}
            {/*    />*/}
            {/*</label>*/}

            <label>
                Öğretmen Rolü
                <select
                    id="teacherRole"
                    name="teacherRole"
                    value={formData.teacherRole}
                    onChange={handleChange}
                >
                    {positionData.positions.map((position) => (
                        <option key={position.id} value={position.id}>
                            {position.name}
                        </option>
                    ))}
                </select>
            </label>
            <LoadingButton onClick={handleSubmit}>
                <span>Değişiklikleri Kaydet</span>
            </LoadingButton>
        </div>
    );
};

export default UserSettings;
